import { createApp } from "vue";
import { toPrix, toDate } from "./composant/b2bLangue";
import html from "./orderMassImport.html";
import { dropzoneFile } from './composant/dropezoneFile'
import orderList from "./orderList";



const Etats = {
    rien: 0,
    errorStructure: 2,
    errorOrder: 3,
    orderOk: 4,
    done: 5,
}
function PrepareData(rows) {
    return rows.map(u => ({
        _id: u._id,
        order: `#${u.numeroErp}`,
        actions: u.actions,
        customer: u.clientV,
        code: u.clientK,
        ordertype: u.ordertype,
        department: u.orderdepartment,
        po: u.po,
        dateCre: u.dateCre,
        nbproducts: u.totaux.qt,
        total: u.totaux.ht,
        devise: u.devise,
        status: u.status,
        badge: getBadge(u),
        checked: false,
        inSearch: true,
        majerp: u.majerp,
    }));
}

const js = ({
    url: function (echangeur) {
            

        console.log(echangeur.hash.u);
        // const u = echangeur.hash.toArray()[0].par.u;
        // if (u) echangeur.addAction("b2b.env.get", { u }, "", "stocks");
        echangeur.addAction('b2b.codification.select', { classe: "market" }, '', 'market');


        
        echangeur.addAction('b2b.toc.list', { env: echangeur.hash.u }, '', 'toc');
        // echangeur.addAction('b2b.codification.select', { classe: "market" }, '', 'market');
        // echangeur.addAction('b2b.codification.select', { classe: "SEASON" }, '', 'season');
        // echangeur.addAction('b2b.env.getDefault', {env: echangeur.hash.u}, '', 'default'); 

    },
    onLoad: function (echangeur) {
        let THIS = this;

        let env = echangeur.hash.u;
        const app = createApp({
            components: {
                'dropzone-file': dropzoneFile,  
            },
            data() { 
                return {
                    etat: Etats.rien,
                    data: {},
                    Etats,
                    orders: [],     // tableau des commandes
                    message: "",     // un petit message décrivat l'état
                    url: "",         // lien vers download all errors.xlsx
                    filename:'',
                    markets: echangeur.toc.rows,
                    market: echangeur.toc.rows[0]._id
                }
            },
            computed: {
            },

            methods: {
                openError(url) {
                    if (url) window.open(url);
                },
                toPrix(value, devise) {
                    return toPrix(value, devise);
                },
                gotoRien() {
                    this.etat = Etats.rien;
                },
                back() {
                    THIS.fin();
                },
                async launchMassImport(filename) {
                    const retour = await THIS.rest('b2b.MassImport.analyzeFile', { filename: filename , env:env, idToc : this.market});
                    if (retour.errorStructure) {
                        this.etat = Etats.errorStructure;
                        this.message = retour.message;
                    }
                    if (retour.errorOrder) {
                        this.etat = Etats.errorOrder;
                        this.message = "There are errors in orders";
                        this.url = retour.url;
                        this.orders = retour.orders;
                        this.errors = retour.errors;
                    }
                    if (retour.orderOk) {
                        this.etat = Etats.orderOk;
                        this.message = "Orders understood, wait for import confirmation";
                        this.orders = retour.orders;
                        this.filename = retour.filename;
                    }
                    if (retour.done) {
                        this.etat = Etats.done;
                        this.message = "Inported orders";
                        this.orders = retour.orders;
                    }   

                },

                async gotoDone() {
                    const retour = await THIS.rest('b2b.MassImport.analyzeFile', { filename: this.filename, writereal: true, etat:Etats.orderOk ,env:env, idToc : this.market});
                    if (retour.done) {
                        this.etat = Etats.done;
                        this.orders = retour.orders;
                    }                    
                },

                gotoClose() {
                    window.location.hash ='#orderList&u='+env;
                },

                toDate(value) {
                    return toDate(value);
                },

                async xls(version) {
                },

                async pdf() {
                },

            },
            watch: {
            },

        });

        this.vm = app.mount(THIS.c$('._vueChargement')[0]);
    },
    reprise: async function (ecran) {

    }
});

export default {
    orderMassImport: { js: js, html: html }
};

